import { useEffect, useState } from 'react';
import { readGoogleMapsConfig } from './config';
import { FleetMapView } from './FleetMapView';
import { useHostBridge } from './useHostBridge';
import { useNow } from './useNow';

/** A van that goes quiet turns OFFLINE within this long of the threshold. */
const CLOCK_TICK_MS = 15_000;

/**
 * Draws what the ERP sends. Idle (an empty page) until the ERP's `init`
 * arrives, so nothing loads from Google for a visit that is not an embed.
 */
export default function App(): React.JSX.Element | null {
  const { state, select, selectStop, reportError } = useHostBridge();
  const [config] = useState(readGoogleMapsConfig);
  const now = useNow(CLOCK_TICK_MS);
  const { init } = state;
  const initialised = init !== null;

  useEffect(() => {
    document.documentElement.dataset['theme'] = init?.theme ?? 'light';
  }, [init?.theme]);

  useEffect(() => {
    if (initialised && config === null) reportError('NOT_CONFIGURED');
  }, [initialised, config, reportError]);

  if (init === null || config === null) return null;

  return (
    <FleetMapView
      config={config}
      init={init}
      vehicles={state.vehicles}
      stops={state.stops}
      trail={state.trail}
      selectedId={state.selectedId}
      selectedStopId={state.selectedStopId}
      now={now}
      onSelect={select}
      onSelectStop={selectStop}
      onError={reportError}
    />
  );
}
